module.exports = __webpack_public_path__ + "media/workplace/rating-good-fill-25fb4778.svg";